
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    star: {
        display: 'inline-block',
        fontSize: '12px'
    },
    star_colorYellow: {
        color: '#F1C73B'
    },
    star_sizeSmall: {
        height: '12px',
        marginRight: '3px',
        width: '12px'
    },
    starSvg: {
        display: 'block',
        fill: 'currentcolor',
        height: '1em',
        width: '1em'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/StarRating/Star/styles.js